import DarkModeIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeIcon from "@mui/icons-material/LightModeOutlined";
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useColorMode, type ColorMode } from "../theme/ColorModeProvider";

const OPTIONS: { value: ColorMode; Icon: typeof LightModeIcon; key: string }[] = [
  { value: "light", Icon: LightModeIcon, key: "theme.light" },
  { value: "dark", Icon: DarkModeIcon, key: "theme.dark" },
  { value: "system", Icon: SettingsBrightnessIcon, key: "theme.system" },
];

/** App-bar toggle for light / dark / system color mode. */
export function ThemeToggle() {
  const { mode, resolved, setMode } = useColorMode();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const { t } = useTranslation();
  const CurrentIcon = mode === "system" ? SettingsBrightnessIcon : resolved === "dark" ? DarkModeIcon : LightModeIcon;
  return (
    <>
      <Tooltip title={t("theme.title")}>
        <IconButton aria-label={t("theme.title")} aria-haspopup="menu" onClick={(e) => setAnchor(e.currentTarget)}><CurrentIcon /></IconButton>
      </Tooltip>
      <Menu open={!!anchor} anchorEl={anchor} onClose={() => setAnchor(null)}>
        {OPTIONS.map(({ value, Icon, key }) => (
          <MenuItem key={value} selected={mode === value} onClick={() => { setMode(value); setAnchor(null); }}>
            <ListItemIcon><Icon fontSize="small" /></ListItemIcon>
            <ListItemText>{t(key)}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
